import { Typography } from 'antd';
import Nudges from '../Nudges';
import CreditScoreView from './CreditScoreView';
import FactorsView from './ImportantFactors';
import LiabilityCardList from './LiabilityCardList';
import Tips from './Tips';
import getNudges from '../../../Utils/nudgeUtils';

const { Title, Text } = Typography;
type Props = {
  onBack: () => void;
};

const LiabilitiesView = ({ onBack }: Props) => {
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: '16px',
        padding: '15px',
        border: '1px solid #f0f0f0',
      }}
    >
      {/* <LeftOutlined
        style={{
          position: 'absolute',
          left: 15,
          top: 15,
        }}
        onClick={onBack}
      /> */}
      <Title level={3}>Your Loans & Credit Cards</Title>
      <div
        style={{
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          gap: 15,
        }}
      >
        <CreditScoreView />
        <Nudges nudgeList={getNudges('liability')} />
        <FactorsView />
        <LiabilityCardList />
        <Tips />
      </div>
    </div>
  );
};

export default LiabilitiesView;
